function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2e3033",
  d: "M33.1 36a2.859 2.859 0 0 1-2.037-.83l-6.681-6.484a16.1 16.1 0 0 1-8.477 2.4A15.744 15.744 0 0 1 0 15.542 15.745 15.745 0 0 1 15.907 0a15.746 15.746 0 0 1 15.908 15.542 15.172 15.172 0 0 1-3.137 9.258l6.458 6.265.034.034a2.873 2.873 0 0 1-.085 4.121A2.9 2.9 0 0 1 33.1 36zM15.907 5.765A9.956 9.956 0 0 0 5.8 15.542a9.955 9.955 0 0 0 10.1 9.775 9.956 9.956 0 0 0 10.107-9.775 9.957 9.957 0 0 0-10.1-9.777z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mag.109e8515.svg";
export { SvgComponent as ReactComponent };